<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted(){
    var userLang = navigator.language.split('-');
    var region = userLang[userLang.length - 1];
  },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
}
</script>
<style>
.spinner-class{
  height: 100vh;
  width: 100%;
  transform: unset !important;
position: fixed;
z-index: 999990;
background:
#eaeaead1;
top: 0;
left: 0;
right: 0;
display: flex;
align-items: center;
justify-content: center;
overflow-y: hidden;
visibility: visible;
}
.spinner-class svg{
  height: 5rem;
  width: 5rem;
}
.visible{
  visibility: hidden;
}
</style>

